exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.modal-content[data-v-bf8e159a]{padding:40px\n}\n.modal-content .form-section[data-v-bf8e159a]{margin-bottom:30px\n}\n.modal-content .status[data-v-bf8e159a]{margin-bottom:10px\n}\n.md-dialog[data-v-bf8e159a]{width:50%;min-width:50%\n}\n.geo-approach[data-v-bf8e159a]{margin-right:20px\n}\n.domains-form[data-v-bf8e159a]{width:100%\n}\n.platforms-form[data-v-bf8e159a]{width:100%\n}\n.pricing-form[data-v-bf8e159a]{width:100%\n}\n.md-chips[data-v-bf8e159a]{width:100%\n}\n#approach[data-v-bf8e159a]{margin-top:15px\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-bf8e159a","scoped":true,"sourceMap":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/shared-components/forms/LicenseFormDialog.vue
// module id = 198
// module chunks = 0